import { Capacitor } from "@capacitor/core";

export const PLATFORM_IS_NATIVE = Capacitor.isNativePlatform();
export const PLATFORM = Capacitor.getPlatform() as "android" | "ios" | "web";
